
                            const chunks = `/// #replace #define SIXTY_UNIFORMS_AREA
#define SIXTY_UNIFORMS_AREA

/* Screen external controls */
uniform float uOn, uGlitchIntensity, uDisplayCode;
uniform sampler2D tLeftSide, tRightSide;

uniform float uTime, uRatio;
uniform bool uMobile;
uniform vec2 uMouse, uResolution;
uniform sampler2D tNoise, tGlitch, tDraw, tLogo, tCode;


/// #replace vec4 baseColorMapSample = texture2D(tMap, vMapUv);
vec2 mapUv = vMapUv;
vec2 sUv = gl_FragCoord.xy / uResolution;
float mouse = length(vec2(uMouse.x * uRatio, uMouse.y) - (vec2((sUv.x - 0.5) * uRatio, sUv.y - 0.5) * 2.));
float pressGlitch = texture2D(tDraw, mapUv).r;
float sinSize = uMobile ? 1000. : 1500.;
float sinusoide = max(0., sin(mapUv.x * 1500.));
sinusoide *= max(0., sin(mapUv.y * 1500.));

mapUv = mix(mapUv, mapUv + sinusoide, 2. * pressGlitch);

vec3 noise = texture2D(tNoise, mapUv * 0.8 + 0.2 * uTime).rgb * texture2D(tNoise, mapUv * 0.8).rgb;
float glitchTexture = texture2D(tGlitch, mapUv).r;
vec2 glitchUv = mapUv + vec2(glitchTexture) * 0.1;
vec4 baseColorMapSample = texture2D(tRightSide, mix(vec2(1.0 - mapUv.x, mapUv.y - 0.004 * uMouse.y), glitchUv, uGlitchIntensity * smoothstep(0.8, .9, (1. - step(0.9, fract(uTime * 0.4))) * sin(uTime * 2.))));

/// #replace #define SIXTY_MAP_AREA
#define SIXTY_MAP_AREA


/** Split screen for 2 face halves **/
vec3 tvColor;

if(uOn > 0.){
    /* Pixelate  */
    vec2 pixelUv = vec2(ceil(mapUv.x * 30.) / 30., ceil(mapUv.y * 30.) / 30.);
    vec3 pixelated = texture2D(tLeftSide, pixelUv).rgb;

    diffuseColor.rgb = mix(diffuseColor.rgb, pixelated, smoothstep(0.52, 0.51, mapUv.y) * step(1. - uGlitchIntensity, sin(uTime * 0.63 + 0.5)));

    /** Running code window **/
    if (uDisplayCode > 0.){
        vec2 codeUv1 = vec2(smoothstep(0.5, 0.24, mapUv.x), smoothstep(0.05, 0.7, mapUv.y));
        float codeWindow1 = smoothstep(0.24, 0.25, mapUv.x) * smoothstep(0.501, 0.5, mapUv.x);
        codeWindow1 *= smoothstep(0.045, 0.05, mapUv.y) * smoothstep(0.51, 0.505, mapUv.y);

        vec2 codeUv2 = vec2(smoothstep(0.8, 0.45, mapUv.x + fract(uTime) * glitchTexture), smoothstep(0.7, 0.99, mapUv.y));
        float codeWindow2 = smoothstep(0.45, 0.455, mapUv.x) * smoothstep(0.801, 0.8, mapUv.x);
        codeWindow2 *= smoothstep(0.7, 0.705, mapUv.y) * smoothstep(0.99, 0.98, mapUv.y);

        float codePos = step(-0.1, sin(uTime * 1.02));
        diffuseColor.rgb = mix(diffuseColor.rgb, texture2D(tCode, mix(codeUv1, codeUv2, codePos)).rgb * 0.3, step(0.3, sin(uTime * 0.6)) * mix(codeWindow1, codeWindow2, codePos));
    }

    /** LOCOMOTIVE LOGO **/
    // vec2 logoUv = vec2(mapUv.x, (1. - mapUv.y - 0.5) * 2. + 0.5);
    // float logo = texture2D(tLogo, mix(logoUv, logoUv + 0.05 * fract(uTime * 2.), step(0.5, logoUv.x))).r;

    // diffuseColor.rgb = mix(diffuseColor.rgb, diffuseColor.rgb * vec3(0., 0., 1.), (1. - logo) * step(mix(1., 0.97, uGlitchIntensity), sin(uTime * 0.8)));

    /** Noise glitch **/
    float glitch = smoothstep(0.75, 0.76, noise.r);
    diffuseColor.rgb += 0.1 * glitch;

    /** Glitch horizontal band **/
    float glitchBand = smoothstep(0.4, 0.401, fract(mapUv.y + 0.5 * uTime)) * smoothstep(0.43, 0.429, fract(mapUv.y + 0.5 * uTime));
    glitchBand *= smoothstep(0.4 + 0.1 * sin(uTime), 0.401 + 0.1 * sin(uTime), mapUv.x);
    glitchBand *= step(mix(1., -0.2, uGlitchIntensity), sin(uTime * 3.));
    diffuseColor.rgb += vec3(0.4, 0.4, 0.9) * glitchBand * 0.5;

    /** Horizontal top band **/
    float horTop = smoothstep(0.80, 0.801, mapUv.y) * step(mix(1., -0.4, uGlitchIntensity), sin(uTime * 0.7));
    vec3 topBand = texture2D(tCode, vec2(1. - (mapUv.x) + uTime * 0.1, mapUv.y - 0.27)).rgb;
    topBand *= vec3(0.2, 0.2, 1.);
    diffuseColor.rgb = mix(diffuseColor.rgb, topBand, horTop);

    /** Glitch vertical red band **/
    float redGlitch = smoothstep(0.32, 0.33, mapUv.x) * smoothstep(0.35, 0.34, glitchUv.x);
    diffuseColor.r += redGlitch * step(mix(1., 0.8, uGlitchIntensity), sin(uTime * 0.9 + 0.3));

    /** Glitch square face bicolor patches **/
    float patchGlitch = step(mix(1., 0.96, uGlitchIntensity), sin(uTime));
    float patchScreen = smoothstep(0.2, 0.201, mapUv.y) * smoothstep(0.401, 0.4, mapUv.y);
    patchScreen *= smoothstep(0.2, 0.201, mapUv.x) * smoothstep(0.401, 0.4, mapUv.x);
    float patchScreen2 = smoothstep(0.22, 0.221, mapUv.y) * smoothstep(0.431, 0.43, mapUv.y);
    patchScreen2 *= smoothstep(0.22, 0.221, glitchUv.x) * smoothstep(0.431, 0.43, glitchUv.x);
    diffuseColor *= 1. - 0.8 * patchScreen * patchGlitch;
    diffuseColor.r += texture2D(tMap, mapUv + 0.3).r * patchScreen * patchGlitch;
    diffuseColor.g += 0.2 * texture2D(tMap, mapUv + 0.26).r * patchScreen2 * patchGlitch;

    /** Glitch blue vertical band + square **/
    float blueGlitch = smoothstep(0.4, 0.41, mapUv.x) * smoothstep(0.71, 0.7, mapUv.x);
    blueGlitch *= smoothstep(0.4, 0.41, mapUv.y) * smoothstep(0.71, 0.7, mapUv.y);
    blueGlitch += smoothstep(0.5, 0.51, glitchUv.x) * smoothstep(0.53, 0.52, glitchUv.x);
    diffuseColor.rg *= 1. - 0.5 * blueGlitch * step(mix(1., 0.6, uGlitchIntensity), sin(uTime * 1.7) * sin(uTime));

    /* RGB Split */
    float rgbSplit = mix(1., 0., (1. - step(0.4, glitchUv.y)) * step(mix(1., 0.2, uGlitchIntensity), sin((2.1 + uGlitchIntensity) * uTime)));
    vec2 rgbUv = (vMapUv - 0.5) * 100000. + 0.5;
    rgbUv = fract(rgbUv);
    diffuseColor.r *= mix(1., rgbSplit, 1. - step(0.666, rgbUv.x));
    diffuseColor.g *= mix(rgbSplit, 1., step(0.333, rgbUv.x) * 1. - step(0.666, rgbUv.x));
    diffuseColor.b *= mix(rgbSplit, 1., 1. - step(0.333, rgbUv.x));

    /* Post-processing */
    /** Global screen effect + blue tint on hover **/
    diffuseColor.rgb *= 1. - (sinusoide * sin(uTime + 0.2) * 0.5);
    diffuseColor.rgb *= 1. - pressGlitch * .05;

    diffuseColor.rbg *= .75; // Reduce brightness

    tvColor = diffuseColor.rgb;
    diffuseColor.rgb = vec3(-0.015); // Augment contrast

} else {
    diffuseColor.rgb = vec3(-0.015); // Augment contrast
}

/// #replace vec3 totalEmissiveRadiance = uEmissive;
    vec3 totalEmissiveRadiance = tvColor * uOn;


`;

                            function replace(chunksCode = '', defaultShader = '') {
                                const chunks = parseCode(chunksCode);
                                chunks.forEach(({ target, replace }) => {
                                    defaultShader = defaultShader.replace(target, replace);
                                });

                                return defaultShader;
                            }

                            function parseCode(code, pattern = '/// #replace') {
                                const replacements = [];
                                const lines = code.trim().split('\n');

                                for (let i = 0; i < lines.length; i++) {
                                    const line = lines[i].trim();
                                    if (line.startsWith(pattern)) {
                                        const target = line.replace(pattern, '');
                                        const replaceLines = [];
                                        let j = i + 1;

                                        while (j < lines.length && !lines[j].trim().startsWith(pattern)) {
                                            const nextLine = lines[j].trim();
                                            if (nextLine) {
                                                replaceLines.push(nextLine);
                                            }
                                            j++;
                                        }

                                        const replace = replaceLines.join('\n');
                                        replacements.push({ target: target.trim(), replace: replace.trim() });

                                        i = j - 1;
                                    }
                                }
                                return replacements;
                            }

                            export default {
                                use: (el) => {
                                    const instance = el.material || el;
                                    instance['fragmentShader'] = replace(chunks, instance['fragmentShader']);
                                    instance.needsUpdate = true;
                                    return el;
                                }
                            }
                        